export default {
  slots: {
    base: 'cursor-pointer hover:ring-stone-600 hover:dark:ring-gray-500',
    label: 'cursor-pointer',
  },
}